import React, { FC, ReactElement } from 'react'

import { FeedProps } from './Feed.props'

import FeedStory from '../FeedStory/FeedStory'

const Feed: FC<FeedProps> = ({
  feed,
  dataTestPrefix,
  country,
  factSources
}) => {
  const timelineFeed = feed.reduce(
    (accFeed, story) => {
      const limit = factSources
        .find((fact) => fact.chart === story?.facts?.chart)?.import_limit

      accFeed.push(
        <FeedStory
          key={story.id}
          story={story}
          dataTestPrefix={dataTestPrefix}
          chartData={`${limit || ''} ${country || ''}`}
        />
      )

      return accFeed
    }, [] as ReactElement[]
  )
  return <>{timelineFeed}</>
}

export default Feed
